import _ from "lodash";
import React from "react";
import classes from "./EntityCohortsDetais.scss";
import classNames from "classnames";
import { connect } from "react-redux";
import {
  FORWARD_MESSAGE_VISIBILITY_CONFIG,
  getFormattedNameForUserType,
  getSubText,
} from "MessagingV2/modules/Utils";
import { useI18n } from "Hooks";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  getDefaultStudentNameOrderPreference,
  getDefaultNameSortPreference,
} from "modules/CommonSelectors";
import MessagingAvatar from "MessagingV2/components/ThreadList/Avatar/Avatar";
import StudentAlerts from "AppComponents/StudentAlerts";

const styles = {
  customAvatarStyle: {
    size: "medium",
  },
};

const EntityCohortsDetails = props => {
  const {
    defaultStudentNameOrderPreference,
    defaultStudentNameSortPreference,
    userType,
    entityData,
    entityKey,
  } = props;
  const subTitleClass = classNames(classes.detailSubTitle, "text-body-2");
  const titleClass = classNames(classes.deatilsTitle, "text-body-1");
  const { t } = useI18n(["common"]);

  const getTitle = () => {
    switch (entityKey) {
      case FORWARD_MESSAGE_VISIBILITY_CONFIG.CHANNELS.key:
        return _.get(entityData, "label");
      case FORWARD_MESSAGE_VISIBILITY_CONFIG.USERS.key: {
        return getFormattedNameForUserType({
          user: entityData,
          orderBy: defaultStudentNameSortPreference,
          defaultStudentNameOrderPreference,
          isFormattedNameV2: true,
        });
      }
    }
  };

  const getSubTitle = () => {
    switch (entityKey) {
      case FORWARD_MESSAGE_VISIBILITY_CONFIG.CHANNELS.key: {
        return t("common:count_members", {
          count: _.get(entityData, "totalUsersCount"),
        });
      }
      case FORWARD_MESSAGE_VISIBILITY_CONFIG.USERS.key: {
        return getSubText({
          loggedInUserRole: userType,
          messagedUserObj: entityData,
          messagedUserRole: _.get(entityData, "type"),
          t,
          defaultStudentNameSortPreference,
        });
      }
    }
  };

  const title = getTitle();
  const subTitle = getSubTitle();
  const studentAlertTypes = _.get(entityData, "alertTypes", []);

  const imageVariable = _.isEqual(
    entityKey,
    FORWARD_MESSAGE_VISIBILITY_CONFIG.CHANNELS.key
  )
    ? "profileImageData.url"
    : "profileImage";
  return (
    <div className={classes.leftContainer}>
      <div className={classes.avatarContainer}>
        <MessagingAvatar
          url={_.get(entityData, imageVariable)}
          icon={_.get(entityData, "profileImageData.icon")}
          id={_.get(entityData, "id")}
          name={title}
          chatType={_.get(entityData, "type")}
          customAvatarContainerClassName={classes.avatarContainer}
          customAvatarStyles={styles.customAvatarStyle}
        />
      </div>
      <div className={classes.detailText}>
        <div className={classes.titleContainer}>
          <div className={titleClass}>{title}</div>
          <StudentAlerts
            studentId={entityData?.id}
            alertTypes={studentAlertTypes}
          />
        </div>
        <div className={subTitleClass}>{subTitle}</div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const userInfo = getUserInfo();
  const userType = userInfo.user_type;
  return {
    defaultStudentNameOrderPreference: getDefaultStudentNameOrderPreference(
      state
    ),
    defaultStudentNameSortPreference: getDefaultNameSortPreference(state),
    userType,
  };
};

export default connect(mapStateToProps, null)(EntityCohortsDetails);
